import { Actions, ActionTypes } from '@appStore/account/actions';
import { SXError } from '@model';

export interface State {
    errors: SXError[];
}

export const initialState: State = {
    errors: []
};

export function reducer(state = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypes.ErrorAdd:
            return { ...state, errors: [...state.errors, action.payload] };

        case ActionTypes.ErrorsClear:
            return { ...state, errors: [] };
    }
    return state;
}

export const getErrors = (state: State) => state.errors;